.actions {
  display: flex;
  flex-direction: row;
  opacity: 0;
  gap: 1.2rem;
  transform: translateX(1rem) scale(0.95);
  transition: all 0.1s ease-in;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;
  padding: 0.8rem 0 0.8rem 0.8rem;

  transition: all 100ms cubic-bezier(0.25, 0.1, 0.25, 1) 0s;
  background-color: transparent;
  overflow-x: hidden;

  @media screen and (min-width: $bp-medium) {
    &:hover {
      cursor: pointer;

      .actions {
        opacity: 1;
        transform: translateX(0) scale(1);
      }
    }
  }

  @media screen and (max-width: #{$bp-medium - 1}) {
    .actions {
      opacity: 1;
      transform: translateX(0) scale(1);
    }
  }
}

.header {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

.left {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
}

.icon-container {
  color: var(--text-color-white);
  font-size: 1.6rem;
  font-weight: 500;

  svg {
    width: 1.6rem;
    height: 1.6rem;
    fill: var(--color-primary-crayola);
  }
}

.text {
  color: var(--color-grayscale-white);
  font-size: 1.2rem;
  font-weight: 400;
  word-break: break-all;

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
  }
}

.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > span {
    font-size: 1.2rem;
    font-weight: 400;
    color: var(--color-grayscale-shuttle);

    @media screen and (min-width: $bp-medium) {
      font-size: 1.4rem;
    }

    &:hover {
      color: var(--color-grayscale-white);
      transition: color 100ms cubic-bezier(0.25, 0.1, 0.25, 1) 0s;
    }
  }
}

.author {
  color: var(--color-grayscale-white);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
  }
}

.time-stamp {
  color: var(--color-grayscale-shuttle);
  font-family: Inter, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  flex: 1 0 auto;
}

.action-container {
  height: 1.6rem;
  width: 1.6rem;
  cursor: pointer;
  color: var(--color-grayscale-shuttle);

  svg {
    height: 1.6rem;
    width: 1.6rem;
  }

  &:hover {
    cursor: pointer;
    svg {
      color: var(--color-grayscale-white);
    }
  }
}

.time-code-container {
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
}

.time-code {
  color: var(--color-primary-crayola);
  font-size: 1.2rem;
  font-weight: 400;

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
  }
}

.comment-container {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
}
